import { useEffect, useRef } from 'react';

import { clearStoredSocialAuth } from './socialAuthStorage';

export const useSocialAuthListener = ({ isActive, onAuthenticated }) => {
  const onAuthenticatedRef = useRef(onAuthenticated);
  const pendingStorageKeysRef = useRef({});

  useEffect(() => {
    onAuthenticatedRef.current = onAuthenticated;
  });

  useEffect(() => {
    if (!isActive) return undefined;

    clearStoredSocialAuth();
    pendingStorageKeysRef.current = {};

    const applyStoredAuth = (storageKey, storedValue) => {
      if (!storedValue) return;
      if (!pendingStorageKeysRef.current[storageKey]) return;

      delete pendingStorageKeysRef.current[storageKey];
      onAuthenticatedRef.current(storageKey, storedValue);
    };

    const handleStorage = (storageEvent) => {
      applyStoredAuth(storageEvent.key, storageEvent.newValue);
    };

    const handleFocus = () => {
      Object.keys(pendingStorageKeysRef.current).forEach((storageKey) => {
        applyStoredAuth(storageKey, window.localStorage.getItem(storageKey));
      });
    };

    window.addEventListener('storage', handleStorage);
    window.addEventListener('focus', handleFocus);

    return () => {
      window.removeEventListener('storage', handleStorage);
      window.removeEventListener('focus', handleFocus);
    };
  }, [isActive]);

  const awaitNetworkAuth = (storageKey) => {
    window.localStorage.removeItem(storageKey);
    pendingStorageKeysRef.current[storageKey] = true;
  };

  return { awaitNetworkAuth };
};
